import React from "react";
import { FileQuestion, ArrowLeft } from "lucide-react";
import { useHistory } from "react-router-dom";

const NotFound = () => {
  const history = useHistory();

  return (
    <div className="min-h-screen bg-[#191c1e] flex items-center justify-center p-4">
      <div className="neumorphic-card rounded-3xl p-8 sm:p-10 max-w-md w-full text-center border border-white/10 space-y-5">
        <div className="w-16 h-16 rounded-2xl bg-purple-500/10 border border-purple-500/20 text-purple-400 flex items-center justify-center mx-auto">
          <FileQuestion size={32} />
        </div>
        <h1 className="text-4xl font-extrabold text-white">404</h1>
        <p className="text-xs text-gray-400">
          A página ou recurso solicitado não foi encontrado no servidor.
        </p>
        <button
          onClick={() => history.replace("/dashboard")}
          className="w-full py-3 px-6 create-event-btn text-xs font-bold text-white rounded-xl shadow-purple-glow flex items-center justify-center gap-2"
        >
          <ArrowLeft size={16} /> Ir para o Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
